var module = angular.module('octopusApp.projects');

module.controller('ProjectReleaseController', function ($scope, busy, $state, $stateParams, projectState, $q, pageTitle, octopusRepository, octoDialog, pollLoop) {
    var isLoading = $scope.isLoading = busy.create();
    var isRefreshing = $scope.isRefreshing = busy.create();
    var projectId = $stateParams.projectId;
    var releaseVersion = $stateParams.version;

    var loop = pollLoop.create($scope, function () { return refreshActiveComponents(); });
    $scope.isEventsLoading = busy.create();
    $scope.snapshotVariables = snapshotVariables;
    $scope.$on('progress-updates', function(event) {
        getReleaseProgression($scope.release);
    });

    function init() {
        isLoading.promise(octopusRepository.Environments.all().then(function (environments) {
            $scope.environments = environments;
        }));

        isLoading.promise(projectState.load().then(function (project) {

            isLoading.promise(octopusRepository.Projects.getChannels(project).then(function(channels) {
                $scope.channels = channels.Items; 
            }));

            isLoading.promise(projectState.deploymentProcessAsync.then(function (currentDeploymentProcess) {
                $scope.currentDeploymentProcess = currentDeploymentProcess;
            }));

            isLoading.promise(octopusRepository.Projects.getReleaseByVersion(project, releaseVersion).then(function (release) {
                getLifecycle(project, release);

                isLoading.promise(octopusRepository.DeploymentProcesses.get(release.ProjectDeploymentProcessSnapshotId).then(function (deploymentProcess) {
                    isLoading.promise(octopusRepository.DeploymentProcesses.getTemplate(deploymentProcess, release.ChannelId, release.Id).then(function (template) {
                        load(project, release);
                        $scope.deploymentProcess = deploymentProcess;
                        $scope.template = template;


                        _.each(template.Packages, function (packageTemplate) {
                            var selectionForStep = _.find(release.SelectedPackages, function (selected) {
                                return selected.StepName === packageTemplate.StepName;
                            });

                            if (selectionForStep) {
                                var pkg = {
                                    StepName: packageTemplate.StepName,
                                    PackageId: packageTemplate.PackageId,
                                    FeedName: packageTemplate.FeedName,
                                    FeedId: packageTemplate.FeedId,
                                    Version: selectionForStep.Version,
                                    Notes: 'Loading...',
                                    State: 'loading'
                                };

                                $scope.packages.push(pkg);

                            }
                        });
                    }));
                }, function () {
                    load(project, release);
                }));
            }));
        }));
    }

    function getLifecycle(project, release) {
        if (release.ChannelId) {
            isLoading.promise(octopusRepository.Channels.get(release.ChannelId).then(function(channel) {
                $scope.channel = channel;
                var lifecycleId = (channel.LifecycleId) ? channel.LifecycleId : project.LifecycleId;
                isLoading.promise(octopusRepository.Lifecycles.get(lifecycleId).then(function (lifecycle) {
                    $scope.lifecycle = lifecycle;
                }));
            }));
        }
        else
    {
        isLoading.promise(octopusRepository.Lifecycles.get(project.LifecycleId).then(function (lifecycle) {
            $scope.lifecycle = lifecycle;
        }));
    }
    }

    function getReleaseProgression(release) {
        isRefreshing.promise(octopusRepository.Releases.progression(release).then(function (progression) {
            $scope.progression = progression;
        }));
    }

    function mergeListData(scopeList, newList, initializeCallback) {
        if (scopeList) {
            scopeList.Items = newList.Items;
            scopeList.Links = newList.Links;
            scopeList.IsStale = newList.IsStale;
            scopeList.ItemsPerPage = newList.ItemsPerPage;
            scopeList.TotalResults = newList.TotalResults;
        }
        else {
            initializeCallback();
        }
    }

    function refreshActiveComponents() {
        var release = $scope.release;
        return isLoading.promise(octopusRepository.Releases.getDeployments(release, ($scope.deployments && $scope.deployments.Page > 0) ? $scope.deployments.Page * $scope.deployments.ItemsPerPage : 0)).then(function (deployments) {
            mergeListData($scope.deployments, deployments, function (){ $scope.deployments = deployments; });
            loadEvents(release.Id);
            return $q.all([loadArtifacts(release.Id), loadProgression(release)]);
        });

        function loadArtifacts(releaseId) {
            return isLoading.promise(octopusRepository.Artifacts.list({regarding: releaseId, skip: ($scope.artifacts && $scope.artifacts.Page > 0) ? $scope.artifacts.Page * $scope.artifacts.ItemsPerPage : 0}).then(function (artifacts) {
                mergeListData($scope.artifacts, artifacts, function (){ $scope.artifacts = artifacts; });
            }));
        }

        function loadEvents(releaseId) {
            return $scope.isEventsLoading.promise(octopusRepository.Events.list({regarding: releaseId, skip: ($scope.events && $scope.events.Page > 0) ? $scope.events.Page * $scope.events.ItemsPerPage : 0}).then(function (events) {
                mergeListData($scope.events, events, function (){ $scope.events = events; });
            }));
        }

        function loadProgression(release){
            isLoading.promise(octopusRepository.Releases.progression(release).then(function (progression) {
                $scope.progression = progression;
            }));
        }
    }

    function load(project, release) {
        pageTitle(project.Name + " release " + release.Version);
        $scope.project = project;
        $scope.release = release;
        $scope.packages = [];
        loop.startImmediately();
    }

    function snapshotVariables() {
        var message = "Octopus takes a snapshot of the variables each time a release is created. By updating the variables, the current snapshot will be discarded, and the latest variables (as seen on the Variables tab) will be imported.";

        if ($scope.currentDeploymentProcess.LastSnapshotId !== $scope.release.ProjectDeploymentProcessSnapshotId) {
            message += " As your deployment process has changed since the release was created, if you removed any deployment steps, keep in mind that variables might also have been deleted that you still rely on for this release.";
        }

        octoDialog.asyncConfirm({
            title: "Confirm variable update",
            message: message,
            executeButtonClass: "btn-danger",
            executeButtonText: "Update variables",
            execute: function (dialog) {
                dialog.busy.promise(octopusRepository.Releases.snapshotVariables($scope.release).then(function(release) {
                    dialog.dismiss();
                    $state.reload();
                }));
            }
        });
    }

    init();
});






//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/controllers/project_release_controller.js
// module id = 523
// module chunks = 1